import Link from 'next/link';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@/shared/components/atoms';
import routes from '@/shared/constant/routes';

import AiIcon from '~/images/AiModule/ai-big-icon.svg';
import RightArrow from '~/images/shared/arrows/arrow-right.svg';

const AiOnbaordingBanner = () => {
  const { t } = useTranslation('ai');

  return (
    <div className='flex items-start justify-between'>
      <div className='flex  gap-2'>
        <span className='h-[60px] w-[60px]'>
          <AiIcon width={60} height={60} />
        </span>
        <div>
          <Typography
            component='h4'
            className=''
            variant='h3'
            style={{ fontWeight: 700 }}
          >
            {t('meet-orth')}
            <span className='mx-2 whitespace-pre rounded-lg bg-[#C2FBE6] p-1 text-14 capitalize'>
              {t('beta')}
            </span>
          </Typography>
          <Typography component='p' variant='subtitle1'>
            {t('onboarding-subtext')}
          </Typography>
        </div>
      </div>
      <Link
        href={routes.aydiIntelligence}
        className='self-center rounded-xl bg-[#1073E1] p-8 text-white'
      >
        <span className='mx-2 flex items-center justify-between gap-2 whitespace-nowrap'>
          {t('ask-orth')}{' '}
          <span className='rtl:rotate-180'>
            <RightArrow width={24} height={24} />
          </span>
        </span>
      </Link>
    </div>
  );
};

export default AiOnbaordingBanner;
